var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHurricane(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M224 96C210.75 96 200 106.75 200 120S210.75 144 224 144C312.219 144 384 215.781 384 304S312.219 464 224 464C210.75 464 200 474.75 200 488S210.75 512 224 512C338.688 512 432 418.688 432 304S338.688 96 224 96ZM264 392C264 378.75 253.25 368 240 368C151.781 368 80 296.219 80 208S151.781 48 240 48C253.25 48 264 37.25 264 24S253.25 0 240 0C125.312 0 32 93.312 32 208S125.312 416 240 416C253.25 416 264 405.25 264 392ZM256 256C256 238.326 241.674 224 224 224S192 238.326 192 256C192 273.672 206.326 288 224 288S256 273.672 256 256Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHurricane);
export default __webpack_public_path__ + "static/media/hurricane.c25d85c0e9528b55ada953e5897c8788.svg";
export { ForwardRef as ReactComponent };